import { Table, TableColumn, Select, Option } from 'element-ui'
import { Pagination as LPagination } from '@/components/index'
import moment from 'moment'
import { VueEditor } from 'vue2-editor'
import ResourceSvc from '@/services/resource.svc.js';
import store from '@/services/store.js';

const svc = new ResourceSvc();

export default {
    props: ['courseId'],
    name: 'AdminSendEmail',
    components: {
        LPagination,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        VueEditor
    },
    data() {
        return {
            mailSending: false,
            submited: false,
            subject: "",
            content: "",
            modelValidations: {
                subject: {
                    required: true,
                    min: 5
                },
                content: {
                    required: true,
                    min: 5
                }
            },
            customToolbar: [
                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                ['bold', 'italic', 'underline', 'strike'],
                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                [{ 'color': [] }, { 'background': [] }],
                ['clean']
                //  [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
                //  [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
                // [{ 'direction': 'rtl' }],                         // text direction                    
                // [{ 'font': [] }],
                // [{ 'align': [] }],

            ],
            title: "Answer Tables",
            searchTimeout: null,
            isForcedLoad: false,
            savedSearchQuery: '',
            searchQuery: '',
            dataLoad: false,
            savedCurrentTypeId: 0,
            pagination: {
                perPage: 5,
                currentPage: 1,
                perPageOptions: [5, 10, 25, 50],
                total: 0,
                savedPageIndex: 0,
                savedPerPage: 0
            },
            userForSearch: null,
            savedUserForSearch: null,
            tableColumns: [
                {
                    prop: 'dateSend',
                    label: 'Date',
                    minWidth: 100
                },
                {
                    prop: 'receiversStr',
                    label: 'Receivers',
                    minWidth: 250
                }
            ],
            tableData: []
        }
    },
    computed: {
        pagedData() {
            return this.tableData.slice(this.from, this.to)
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1)
        },
        total() {
            this.pagination.total = store.getters.getTotalEmailCount;
            return store.getters.getTotalEmailCount;
        },
        attendantsCount() {
            return store.getters.getCourseAttendantsTotal; 
        }
    },
    methods: {
        getError(fieldName) {
            return this.errors.first(fieldName)
        },
        validate() {
            var that = this;
            this.submited = true;
            this.$validator.validateAll().then(isValid => {
                var tempContent = that.content.replace(/<\/?[^>]+(>|$)/g, "");
                tempContent = tempContent.replace(/ /g, '');
                if (!tempContent) {
                    that.content = '';
                    isValid = false;
                    return;
                }
                if (isValid)
                    that.send();
            });
        },
        queriedData(forced) {
            if (this.courseId == 0)
                return [];
            //            / add  perPageOptions aption to show all (if count > max (50))

            if (this.dataLoad)
                return this.tableData;

            if (this.pagination.savedPageIndex == this.pagination.currentPage && this.pagination.perPage == this.pagination.savedPerPage && !forced)
                return this.tableData;

            var conf = { courseId: this.courseId, take: this.pagination.perPage, skip: this.from };
            if (conf.skip < 0) {
                conf.skip = 0;
            }

            while (this.pagination.total <= conf.skip && conf.skip) {
                this.pagination.currentPage--;
                conf.skip -= this.pagination.perPage;
                if (conf.skip < 0) {
                    conf.skip = 0;
                }
            }

            this.dataLoad = true;
            var self = this;

            svc.getMailingHistory(conf).then(response => {
                self.dataLoad = false;
                self.tableData = response.body.data;
                store.commit('setTotalEmailCount', response.body.count);
                self.pagination.savedPageIndex = self.pagination.currentPage;
                self.pagination.savedPerPage = self.pagination.perPage;

                self.tableData.forEach(function (item) {
                    item.dateSend = self.dateFormat(item.dateSend); // rewrite to usefull format
                    item.receiversStr = self.buildReceiversProp(item);
                    item.text = "<p><b>Subject: </b>" + item.subject + "</p><br />" + item.text
                });

                return self.tableData;
            }, response => {
                self.tableData = [];
                self.pagination.savedPageIndex = self.pagination.currentPage;
                self.pagination.savedPerPage = self.pagination.perPage;
                self.dataLoad = false;
                self.isForcedLoad = false;
                return [];
            });
        },

        send() {
            if (this.mailSending || !this.subject || !this.content)
                return;
            this.mailSending = true;
            var body = {
                CourseId: parseInt(this.courseId),
                Subject: this.subject,
                Body: this.content
            };
            var that = this;
            svc.sendEmailToAllCourseAttendants(body).then(response => {
                that.submited = false;
                that.subject = "";
                that.content = "";

                this.$notify({
                    message: "Email successfully sent!",
                    type: 'success'
                });
                that.tableData = that.queriedData(true);
                that.mailSending = false;
            }, response => {
                this.$notify({
                    title: "Error!",
                    message: "Error while sending! Try again.",
                    type: 'danger'
                });
                that.mailSending = false;
            });
            return;
        },
        dateFormat(date) {
            if (date) {
                var dateUtc = moment.utc(String(date)).toDate();
                return moment(dateUtc).local().format('MM/DD/YYYY hh:mm');
            }
        },
        buildReceiversProp(mail) {
            var str = "";
            mail.receivers.forEach(function (receiver) {
                str += receiver.firstName + " " + receiver.lastName + " " + "(" + receiver.email + ")\n";
            });
            return str;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/admin/courses/course-details/send-email/send-email.js